import useGetApi from 'src/api/useGetApi';
import { UserDocument, DocumentStatus } from 'src/types/UserDocuments';

export interface ListDocumentsParams {
  status?: DocumentStatus;
  limit?: number;
  offset?: number;
}

export interface ListDocumentsResponse {
  count: number;
  results: UserDocument[];
}

const useListDocuments = (params?: ListDocumentsParams) => {
  return useGetApi<ListDocumentsResponse>({
    endpoint: 'core/documents',
    queryParameters: params,
  });
};

export default useListDocuments;
